<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Raised buttons types and colors" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="(button, index) in buttons" :key="`0-${index}`" md12 xs24>
        <vc-button block :color="button.color">{{ button.color }}</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-2.html" title="Raised buttons icons on the left" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="(button, index) in buttons" :key="`1-${index}`" md12 xs24>
        <vc-button block :icon-left="button.iconLeft" :color="button.color">{{ button.color }}</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-3.html" title="Raised buttons icons on the right" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="(button, index) in buttons" :key="`2-${index}`" md12 xs24>
        <vc-button block :icon-right="button.iconRight" :color="button.color">{{ button.color }}</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-4.html" title="Icon Only" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="(button, index) in buttons" :key="`8-${index}`" md12 xs24>
        <vc-button block :color="button.color">
          <vc-icon>{{ button.iconLeft }}</vc-icon>
        </vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-9.html" title="Icon Button" />
    <vc-layout :spacing="8">
      <vc-col :span="4" v-for="(button, index) in buttons" :key="`8-${index}`">
        <vc-button icon-button :color="button.color">
          <vc-icon>{{ button.iconLeft }}</vc-icon>
        </vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-5.html" title="Button sizes" />
    <vc-layout :spacing="8">
      <vc-col :span="8" v-for="(button, index) in sizes" :key="`4-${index}`" xs24>
        <vc-button block :size="button.size" :icon-left="button.iconLeft" :color="button.color">{{ button.size }}</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-6.html" title="Buttons as HTML links" />
    <vc-layout :spacing="8">
      <vc-col :span="8" v-for="(button, index) in links" :key="`6-${index}`" xs24>
        <vc-button block tag="a" :to="button.url" target="_blank" icon-left="link" color="primary">{{ button.url }}</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-7.html" title="Buttons as Vue router-links" />
    <vc-layout :spacing="8">
      <vc-col :span="8" v-for="(button, index) in sizes" :key="`7-${index}`" xs24>
        <vc-button block tag="router-link" :to="button.to" icon-right="chevron_right" color="error">{{ button.to }}</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-10.html" title="Buttons with @click handler (open console)" />
    <vc-layout :spacing="8">
      <vc-col :span="8" v-for="(button, index) in sizes" :key="`8-${index}`" xs24>
        <vc-button @click="onClick($event)" block icon-right="chevron_right" color="purple">click me</vc-button>
      </vc-col>
    </vc-layout>

    <example-title src="example-8.html" title="Block button, occupying the entire width of their parent" />
    <vc-layout :spacing="8">
      <vc-col :span="24">
        <vc-button block icon-left="home" color="deep-purple">block button</vc-button>
      </vc-col>
    </vc-layout>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ButtonPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      buttons: [{
        color: 'default',
        iconLeft: 'home',
        iconRight: 'home',
        url: 'https://wemakesites.net'
      }, {
        color: 'primary',
        iconLeft: 'check_circle',
        iconRight: 'home',
        url: 'https://martinivanov.net'
      }, {
        color: 'info',
        iconLeft: 'info',
        iconRight: 'home',
        url: 'https://vueribbon.com'
      }, {
        color: 'warning',
        iconLeft: 'warning',
        size: 'small',
        iconRight: 'home',
        to: '/components/alert'
      }, {
        color: 'success',
        iconLeft: 'thumb_up',
        size: 'normal',
        iconRight: 'home',
        to: '/'
      }, {
        color: 'error',
        iconLeft: 'error',
        size: 'large',
        iconRight: 'home',
        to: '/components/list'
      }]
    }
  },
  computed: {
    sizes () {
      return this.buttons.filter(button => button.size)
    },
    links () {
      return this.buttons.filter(button => button.url)
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onClick (event) {
      console.log('vc-button:click', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/button.vue